import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=4f4fcb7c&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=ts"
export * from "./MyTeam.vue?vue&type=script&lang=ts"
import style0 from "./MyTeam.vue?vue&type=style&index=0&id=4f4fcb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4fcb7c",
  null
  
)

export default component.exports